import _ from 'underscore';
import Marionette from 'backbone.marionette';
import PaginationView from 'base/views/page';
import DialogService from 'base/dialog_service';

import { Filter } from 'forms/filter/model';
import { FilterView } from 'forms/filter/view';

import PrintCodesView from 'joinos_codes/views/print';

const CodeView = Marionette.LayoutView.extend({
  template: require('../templates/item.html'),
  tagName: 'tr',
  templateHelpers() {
    return {
      letter_url: this.model.letter_url()
    };
  },
  className(){
    if(this.getOption('odd')){
      return 'alt';
    }
  },
  ui: {
    cancelButton: '.cancel-button'
  },
  triggers: {
    'click @ui.cancelButton': 'cancel'
  },
  onCancel(){
    if(confirm('Are you sure you want to cancel this Joinos Code?')){
      document.location.href = this.model.cancel_url();
    }
  }
});

const ListView = Marionette.CompositeView.extend({
  template: require('../templates/list.html'),
  childView: CodeView,
  childViewContainer: 'tbody',
  childViewOptions(model, index) {
    const opts = _.clone(this.options);
    opts.odd = index % 2;
    return opts;
  }
});

const JoinosCodeListView = Marionette.LayoutView.extend({
  template: require('../templates/layout.html'),
  regions: {
    list: '.list-hook',
    filter: '.filter-hook',
    paging: '.pagination-hook'
  },
  ui: {
    buttonPrint: '.button-print'
  },
  triggers: {
    'click @ui.buttonPrint': 'print'
  },

  onPrint(){
    let view = new PrintCodesView();
    let m = DialogService.show(view);

    view.on('close', () => {
      m.close();
    });
  },

  onRender(){
    this.showChildView('list', new ListView({
      collection: this.collection
    }));
    this.showChildView('filter', new FilterView({
      collection: this.collection,
      model: new Filter()
    }));
    this.showChildView('paging', new PaginationView({
      collection: this.collection
    }));
  }
});

export default JoinosCodeListView;



// WEBPACK FOOTER //
// ./joinos_codes/views/list.js